import gql from "graphql-tag";

export const PRODUCTS = gql`
  query products($where: ProductWhereInput) {
    products(where: $where) {
      data {
        sn
        sn2
        receiptLinekey
        receiptNo
        productCode
        productRef
        productDesc
        productPhoto
        productBrand
        purchaseDate
        openFolderNumber
      }
      count
    }
  }
`;

export const PRODUCT = gql`
  query product($where: ProductWhereInput) {
    product(where: $where) {
      data {
        sn
        sn2
        receiptLinekey
        receiptNo
        productCode
        productRef
        productDesc
        productPhoto
        productBrand
        purchaseDate
        openFolderNumber
      }
      count
    }
  }
`;

export const PRODUCT_BY_REF = gql`
  query productByRef($where: ProductWhereInput) {
    productByRef(where: $where) {
      data {
        productCode
        productRef
        productDesc
        productPhoto
        productBrand
      }
      count
    }
  }
`;
